export const VUEX_WIP_INITIALIZE                 = 'VUEX_WIP_INITIALIZE'

export const VUEX_WIP_FETCH_JOBS                 = 'VUEX_WIP_FETCH_JOBS'
export const VUEX_WIP_FETCH_JOBS_SUCCESS         = 'VUEX_WIP_FETCH_JOBS_SUCCESS'
export const VUEX_WIP_SET_CANCEL_REQUEST         = 'VUEX_WIP_SET_CANCEL_REQUEST'

export const VUEX_WIP_INCREMENT_PAGINATION_PAGE  = 'VUEX_WIP_INCREMENT_PAGINATION_PAGE'
export const VUEX_WIP_RESET_PAGINATION_PAGE      = 'VUEX_WIP_RESET_PAGINATION_PAGE'

export const VUEX_WIP_RESET                      = 'VUEX_WIP_RESET'